module.exports = {
      id: "newslettericon-usage",
      viewBox: "0 0 48 47.861",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#newslettericon",
      toString: function () {
        return this.url;
      }
    }